import { Chip, TableCell, TableRow, Tooltip } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../../components/shared/useUser';
import { ModuleResponse } from '../../../../app/services/api/generated';
import { useTranslation } from 'react-i18next';

type Props = {
  module: ModuleResponse;
};

const ModuleItemRow: FC<Props> = ({ module }) => {
  const { t } = useTranslation('admin');
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['ModuleUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/admin/modules/edit/${module.id}`);
  };

  const truncateText = (text: string | undefined, maxLength: number = 40) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>
        <Tooltip title={module.name || ''}
          placement="top">
          <span>{truncateText(module.name)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Tooltip title={module.description || ''}
          placement="top">
          <span>{truncateText(module.description)}</span>
        </Tooltip>
      </TableCell>
      <TableCell>{module.systemName || '-'}</TableCell>
      <TableCell align="center">
        <Chip
          label={module.premium ? t('modules.yes') : t('modules.no')}
          color={module.premium ? 'primary' : 'default'}
          size="small"
        />
      </TableCell>
      <TableCell align="center">
        {module.permissions?.length ?? 0}
      </TableCell>
    </TableRow>
  );
};

export default ModuleItemRow;
